import axios from 'axios';

const API_HOST = process.env.REACT_APP_API_BASE_PATH;

export const getStripeChargeEventsData = params =>
  axios.get(`${API_HOST}/stripe/charge/event/list`, {
    params,
    withCredentials: true
  });

export const gochiResendMail = (identityId, params) =>
  axios.post(`${API_HOST}/identities/${identityId}/groupStatus`, params, {
    withCredentials: true
  });
